import { BookHome } from "~/sections";
import { json, LoaderFunctionArgs, MetaFunction } from "@remix-run/node";
import { useLoaderData } from "@remix-run/react";
import { IBookDetailResponse } from "~/utils/interface";

export async function loader({ params }: LoaderFunctionArgs) {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_API_URL}/books/${params.bookId}`,
    );
    const book = await response.json();

    if (!book) throw new Response("", { status: 404 });
    return json(book);
  } catch (error) {
    console.error("Failed to fetch initial blocks:", error);
    throw new Response("Failed to load catalog data", { status: 500 });
  }
}

export const meta: MetaFunction = (data) => {
  const title = data?.data?.data?.title;
  return [
    { title: `Tempt - ${title}` },
    {
      name: "description",
      content: `Your #1 Romance Audiobook App with Unlimited Listening. Read aтd enjoy ${title}`,
    },
  ];
};

export default function Book() {
  const { data } = useLoaderData<IBookDetailResponse>();
  return (
    <>
      <BookHome
        id={data.id}
        authors={data.authors}
        title={data.title}
        description={data.description}
        tags={data.tags}
        authors_data={data.authors_data}
        cover={data.cover}
        spicy={data.spicy}
        narrator_type={data.narrator_type}
        narrators={data.narrators}
        mood={data.mood}
        rating={data.rating}
        sample={data.sample}
        serial_number={data.serial_number}
        series_name={data.series_name}
        series={data.series}
        emoji={data.emoji}
        total_duration={data.total_duration}
        narrators_data={data.narrators_data}
        is_free={data.is_free}
        free_chapters={data.free_chapters}
        total_chapters={data.total_chapters}
      />
    </>
  );
}
